import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';







export default class Contactus extends Component {

    mathrating(ratings) {
        const starTotal = 5;
        const starPercentage = (ratings / starTotal) * 100;
        var starPercentageRounded = `${(Math.round(starPercentage / 10) * 10)}%`;
        return starPercentageRounded
    }

    render() {
        return (
            <div className="Contact-us">

                <form className="container" noValidate autoComplete="off">
                    <TextField
                        id="outlined-name"
                        label="نام و نام خانوادگی"
                        className="textField contact-input"
                        // value={this.state.name}
                        // onChange={this.handleChange('name')}
                        margin="normal"

                    />
                    <TextField
                        id="outlined-email-input"
                        label="پست الکترونیکی"
                        className="textField contact-input"
                        type="email"
                        name="email"
                        autoComplete="email"
                        margin="normal"

                    />
                    <TextField
                        id="outlined-number"
                        label="تلفن همراه"
                        // value={this.state.age}
                        // onChange={this.handleChange('age')}
                        // type="number"
                        className="textField contact-input"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        margin="normal"
                        defaultValue='09'
                    />
                    <TextField
                        id="standard-multiline-flexible"
                        label="پیام"
                        multiline
                        rowsMax="4"
                        // value={this.state.multiline}
                        // onChange={this.handleChange('multiline')}
                        className="textField contact-input"
                        margin="normal"
                    />
                    <div className="send-button">
                        <Button variant="contained" className="button send-but" >
                            ارسال
                        </Button>
                    </div>
                </form>
            </div>
        )

    }

}


// WEBPACK FOOTER //
// ./src/containers/merchants/contactuser.jsx